import React from 'react';

interface TickerItem {
    symbol: string;
    name: string;
    price: number;
    change24h: number;
    icon?: string;
}

interface PriceTickerProps {
    items: TickerItem[];
    className?: string;
}

const formatPrice = (price: number): string => {
    if (price >= 1000) {
        return price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 6 });
};

const formatChange = (change: number): string => {
    const sign = change >= 0 ? '+' : '';
    return `${sign}${change.toFixed(2)}%`;
};

export const PriceTicker: React.FC<PriceTickerProps> = ({ items, className = '' }) => {
    // Duplicate items for seamless loop
    const duplicatedItems = [...items, ...items];

    return (
        <div className={`trader-ticker ${className}`}>
            <div className="trader-ticker-inner">
                {duplicatedItems.map((item, index) => (
                    <div key={`${item.symbol}-${index}`} className="trader-ticker-item">
                        <span className="trader-ticker-symbol">
                            {item.icon && <img src={item.icon} alt={item.symbol} />}
                            <span>{item.symbol}/USDT</span>
                        </span>
                        <span className="trader-ticker-price">${formatPrice(item.price)}</span>
                        <span className={`trader-ticker-change ${item.change24h >= 0 ? 'positive' : 'negative'}`}>
                            {formatChange(item.change24h)}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PriceTicker;
